<mat-card class="mat-elevation-z0 upper-space">
  <div class="upper-space">
    <div class="section-title-margin">
      <span class="section-title">{{ productLabel }} </span>

      <span *ngIf="multipleProducts" class="product-number">
        #{{ index + 1 }}
      </span>
    </div>

    <!-- Material and extra description -->

    <div class="product-info-display">
      <div class="product-info">
        <div *ngIf="windowSticker != null">
          <span class="strong">Materiaal: </span>

          <span>
            {{
              windowSticker.temporaryMaterial
                | formatBoolean : false : 'Tijdelijk' : 'Permanent'
            }}
          </span>

          <span *ngIf="windowSticker.foil != null">
            - {{ windowSticker.foil.name }}
          </span>

          <span *ngIf="windowSticker.laminate != null">
            - {{ windowSticker.laminate.name }}
          </span>

          <ng-container *ngIf="standardStickerPartDisplays?.length > 0">
            <div
              *ngFor="
                let display of standardStickerPartDisplays;
                let index = index;
                trackBy: trackById
              "
            >
              <span class="strong">
                Sticker{{ multipleProductParts ? display.indexDisplay : '' }}:
              </span>

              <span *ngIf="display.size?.length > 0">{{ display.size }}</span>

              <span
                *ngIf="
                  display.size?.length > 0 &&
                  display.layoutDescription?.length > 0
                "
              >
                -
              </span>

              <span
                *ngIf="display.layoutDescription?.length > 0"
                class="preserve-line-break"
              >
                {{ display.layoutDescription }}
              </span>
            </div>
          </ng-container>

          <ng-container *ngIf="customStickerPartDisplays?.length > 0">
            <div
              *ngFor="
                let display of customStickerPartDisplays;
                let index = index;
                trackBy: trackById
              "
            >
              <span class="strong">
                Raam{{ multipleProductParts ? display.indexDisplay : '' }}:
              </span>

              <span>{{ display.windowSize | or }} - </span>

              <span class="strong">
                Sticker{{ multipleProductParts ? display.indexDisplay : '' }}:
              </span>

              <span>{{ display.stickerSize | or }}</span>

              <span *ngIf="display.description?.length > 0"> - </span>

              <span
                *ngIf="display.description?.length > 0"
                class="preserve-line-break"
              >
                {{ display.description }}
              </span>
            </div>
          </ng-container>
        </div>

        <!-- Boards -->

        <div *ngIf="board != null">
          <ng-container *ngIf="boardPartDisplays?.length > 0">
            <div
              *ngFor="
                let display of boardPartDisplays;
                let index = index;
                trackBy: trackById
              "
            >
              <div *ngIf="multipleProductParts" class="strong">
                Bord{{ display.indexDisplay }}:
              </div>

              <ul class="inpress-ul">
                <li>
                  <span class="strong">Formaat: </span>
                  {{ display.size }}
                </li>

                <li>
                  <span class="preserve-line-break display-contents">
                    <span class="strong">Materiaal: </span>
                    {{ display.materialDisplay }}
                  </span>
                </li>

                <li>
                  <span class="strong">Bordtype: </span>
                  {{ display.boardType }}
                </li>

                <li>
                  <span class="strong">Plaatsing: </span>
                  {{ display.placementType }}
                </li>

                <li *ngIf="display.showDistanceToBottom">
                  <span class="preserve-line-break display-contents">
                    <span class="strong">Afstand tot onderkant bord: </span>
                    {{ display.distanceToBottomDisplay }}
                  </span>
                </li>

                <li *ngIf="display.paintedPostsDisplay?.length > 0">
                  <span class="strong">Geschilderde constructie: </span>
                  {{ display.paintedPostsDisplay }}
                </li>

                <li>
                  <span class="preserve-line-break display-contents">
                    <span class="strong">Omschrijving klant: </span>
                    {{ display.layoutDescription }}
                  </span>
                </li>
              </ul>
            </div>
          </ng-container>
        </div>

        <!-- Other product -->

        <div *ngIf="otherProduct != null">
          <div>
            <span class="strong">Materiaal: </span>

            <span>{{ otherProduct.otherProductMaterial | or }}</span>
          </div>

          <div class="preserve-line-break">
            <span class="strong">Extra info: </span>

            <span class="display-text">
              {{ otherProduct.layoutDescription | or }}
            </span>
          </div>
        </div>
      </div>

      <div class="product-info">
        <div class="product-design">
          <div *ngIf="designAsset != null">
            <div class="asset-label">Ontwerp</div>

            <div class="loadedImg" matTooltip="{{ designAsset.asset.name }}">
              <div class="d-flex box click-link" class="max-image-width">
                <a
                  download="{{ designAsset.asset.name }}"
                  href="/api/assets/{{ designAsset.asset.uuid }}"
                  style="margin-right: 7px"
                  class="d-flex box secondary-color"
                >
                  <div class="filename">
                    {{ designAsset.asset.name | shortenTextSplitOn : '.' : 10 }}
                  </div>

                  <a>
                    <mat-icon aria-hidden="false" aria-label="remove">
                      cloud_download
                    </mat-icon>
                  </a>
                </a>
              </div>

              <img
                *ngIf="isImage(designAsset.asset)"
                class="max-image-width max-image-height clickable"
                src="/api/assets/{{ designAsset.asset.uuid }}"
                (click)="openDesignLightbox()"
              />
            </div>
          </div>

          <div *ngIf="designLocationAsset != null">
            <div class="asset-label">Ontwerp + impressie</div>

            <div
              class="loadedImg"
              matTooltip="{{ designLocationAsset.asset.name }}"
            >
              <div class="d-flex box click-link" class="max-image-width">
                <a
                  download="{{ designLocationAsset.asset.name }}"
                  href="/api/assets/{{ designLocationAsset.asset.uuid }}"
                  style="margin-right: 7px"
                  class="d-flex box secondary-color"
                >
                  <div class="filename">
                    {{
                      designLocationAsset.asset.name
                        | shortenTextSplitOn : '.' : 10
                    }}
                  </div>

                  <a>
                    <mat-icon aria-hidden="false" aria-label="remove">
                      cloud_download
                    </mat-icon>
                  </a>
                </a>
              </div>

              <img
                *ngIf="isImage(designLocationAsset.asset)"
                class="max-image-width max-image-height clickable"
                src="/api/assets/{{ designLocationAsset.asset.uuid }}"
                (click)="openDesignLocationLightbox()"
              />
            </div>
          </div>
        </div>

        <div
          class="product-design"
          *ngIf="board != null"
          [ngClass]="
            designAsset != null || designLocationAsset != null
              ? 'upper-space'
              : ''
          "
        >
          <div
            *ngIf="locationVerificationProjectWideDisplay.locationAsset != null"
          >
            <div class="asset-label">Locatie (vooraanzicht)</div>

            <div
              class="loadedImg"
              matTooltip="{{
                locationVerificationProjectWideDisplay.locationAsset.asset.name
              }}"
            >
              <div class="d-flex box click-link" class="max-image-width">
                <a
                  download="{{
                    locationVerificationProjectWideDisplay.locationAsset.asset
                      .name
                  }}"
                  href="/api/assets/{{
                    locationVerificationProjectWideDisplay.locationAsset.asset
                      .uuid
                  }}"
                  style="margin-right: 7px"
                  class="d-flex box secondary-color"
                >
                  <div class="filename">
                    {{
                      locationVerificationProjectWideDisplay.locationAsset.asset
                        .name | shortenTextSplitOn : '.' : 10
                    }}
                  </div>

                  <a>
                    <mat-icon aria-hidden="false" aria-label="remove">
                      cloud_download
                    </mat-icon>
                  </a>
                </a>
              </div>

              <img
                *ngIf="
                  isImage(
                    locationVerificationProjectWideDisplay.locationAsset.asset
                  )
                "
                class="max-image-width max-image-height clickable"
                src="/api/assets/{{
                  locationVerificationProjectWideDisplay.locationAsset.asset
                    .uuid
                }}"
                (click)="openSitePhotosLightbox()"
              />
            </div>
          </div>

          <div
            *ngIf="
              locationVerificationProjectWideDisplay.topdownLocationAsset !=
              null
            "
          >
            <div class="asset-label">Locatie (bovenaanzicht)</div>

            <div
              class="loadedImg"
              matTooltip="{{
                locationVerificationProjectWideDisplay.topdownLocationAsset
                  .asset.name
              }}"
            >
              <div class="d-flex box click-link" class="max-image-width">
                <a
                  download="{{
                    locationVerificationProjectWideDisplay.topdownLocationAsset
                      .asset.name
                  }}"
                  href="/api/assets/{{
                    locationVerificationProjectWideDisplay.topdownLocationAsset
                      .asset.uuid
                  }}"
                  style="margin-right: 7px"
                  class="d-flex box secondary-color"
                >
                  <div class="filename">
                    {{
                      locationVerificationProjectWideDisplay
                        .topdownLocationAsset.asset.name
                        | shortenTextSplitOn : '.' : 10
                    }}
                  </div>

                  <a>
                    <mat-icon aria-hidden="false" aria-label="remove">
                      cloud_download
                    </mat-icon>
                  </a>
                </a>
              </div>

              <img
                *ngIf="
                  isImage(
                    locationVerificationProjectWideDisplay.topdownLocationAsset
                      .asset
                  )
                "
                class="max-image-width max-image-height clickable"
                src="/api/assets/{{
                  locationVerificationProjectWideDisplay.topdownLocationAsset
                    .asset.uuid
                }}"
                (click)="openTopdownLocationLightbox()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-container
      *ngIf="locationVerificationProjectWideDisplay.subProject.withPlacement"
    >
      <div
        *ngIf="locationVerificationProjectWideDisplay.hasAddress"
        class="small-upper-space"
      >
        <div class="form-title small-upper-space">
          <div class="form-title-text">Adres</div>
        </div>

        <div class="d-flex">
          <div class="address-display">
            <div>
              <span class="strong">Adres: </span>

              <span>
                {{
                  locationVerificationProjectWideDisplay.subProject
                    .projectPlacement.address.line1
                    | printAddress
                      : locationVerificationProjectWideDisplay.subProject
                          .projectPlacement.address.postalCode
                      : locationVerificationProjectWideDisplay.subProject
                          .projectPlacement.address.city
                }}
              </span>
            </div>

            <div>
              <span class="strong">Afstand: </span>

              <span>
                {{
                  (locationVerificationProjectWideDisplay.kilometersTo
                    | asFormatDecimal : false : 2
                    | or) + ' km'
                }}
              </span>
            </div>
          </div>

          <div class="google-streetview-button-container">
            <div class="google-streetview-link-button clickable action-button">
              <a
                href="{{
                  locationVerificationProjectWideDisplay.panoId
                    | googleStreetviewLink
                }}"
                target="_blank"
              >
                Google
              </a>
            </div>
          </div>
        </div>

        <div class="small-upper-space">
          <textarea-input
            *ngIf="
              locationVerificationProjectWideDisplay.subProject.type ===
              'BaseProject'
            "
            [initContent]="
              locationVerificationProjectWideDisplay.subProject.projectPlacement
                .extraInfoAddress
            "
            [placeholder]="'Extra info adres'"
            [sensitive]="true"
            (answer)="extraInfoAddressChanged($event)"
          ></textarea-input>
        </div>

        <div>
          <span class="strong">Klant kan de locatie bepalen: </span>
          <span>
            {{
              locationVerificationProjectWideDisplay.subProject.projectPlacement
                .hasPictureOfLocationDescription
                | formatBoolean
                | or
            }}
          </span>
        </div>

        <textarea-input
          [title]="'Extra opmerkingen locatie'"
          [initContent]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
              .extraInfoSite
          "
          [placeholder]="
            'Is de locatie goed bereikbaar (Struiken of takken snoeien, parkeren, markt op het plein, ...)'
          "
          [sensitive]="true"
          (answer)="extraInfoSiteChanged($event)"
        ></textarea-input>

        <file-picker
          [title]="locationVerificationProjectWideDisplay.sitePhotosTitle"
          [inputProjectPlacement]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
          "
          [formSection]="'sitePhotos'"
          [watchProjectPlacementAssetsChanges]="true"
          (answer)="locationAssetsUpdated.emit()"
          (assetDeleted)="locationAssetsUpdated.emit()"
        ></file-picker>

        <file-picker
          [title]="'Afbeelding ontwerp + impressie'"
          [inputProduct]="product"
          [formSection]="designFormSection"
          (answer)="preprocessAssets()"
          (assetDeleted)="designLocationDeleted()"
        ></file-picker>

        <file-picker
          *ngIf="
            locationVerificationProjectWideDisplay.showTopdownLocationPhoto
          "
          [title]="'Afbeelding locatie (bovenaanzicht)'"
          [inputProjectPlacement]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
          "
          [formSection]="'locationTopdown'"
          [watchProjectPlacementAssetsChanges]="true"
          (answer)="locationAssetsUpdated.emit()"
          (assetDeleted)="locationAssetsUpdated.emit()"
        ></file-picker>
      </div>

      <div class="form-title small-upper-space">
        <div class="form-title-text">Locatie en uitvoering</div>
      </div>

      <yes-no-unknown
        *ngIf="
          board != null &&
          locationVerificationProjectWideDisplay.showUndergroundPipeworkQuestion
        "
        [title]="'Ondergrondse leidingen aanwezig?'"
        [value]="
          locationVerificationProjectWideDisplay.subProject.projectPlacement
            .undergroundPipework
        "
        [inputText]="
          locationVerificationProjectWideDisplay.subProject.projectPlacement
            .undergroundPipeworkText
        "
        [sensitiveText]="true"
        (answer)="undergroundPipeworkChanged($event)"
        (answeredText)="undergroundPipeworkTextChanged($event)"
      ></yes-no-unknown>

      <textarea-input
        *ngIf="board != null"
        [title]="'Hoe plaatsen'"
        [placeholder]="'45°, parallel'"
        [initContent]="board.placeInstructions"
        (answer)="placeInstructionsChanged($event)"
      ></textarea-input>

      <textarea-input
        [title]="'Info van klant omtrent de plaatsing'"
        [initContent]="
          locationVerificationProjectWideDisplay.subProject.projectPlacement
            .extraPlacementInfo
        "
        [placeholder]="'Info van klant'"
        [sensitive]="true"
        (answer)="extraPlacementInfoChanged($event)"
      ></textarea-input>

      <textarea-input
        [title]="'Info voor de installateur'"
        [placeholder]="'Interne info. Klant leest niet mee.'"
        [initContent]="product.productPlacement.installerInfo"
        (answer)="installerInfoChanged($event)"
      ></textarea-input>

      <ng-container
        *ngIf="locationVerificationProjectWideDisplay.showFloorQuestion"
      >
        <div>
          <span class="strong">Verdieping</span>
        </div>

        <floor-picker
          [(ngModel)]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
              .placementFloor
          "
          [disabled]="disabled"
        ></floor-picker>
      </ng-container>

      <yes-no
        [title]="'Hoogwerker'"
        [showExtraInstructionsOn]="'Ja'"
        [value]="product.productPlacement.extraHoogwerker"
        [nullable]="true"
        [nullIsFalse]="false"
        [inputText]="product.productPlacement.extraHoogwerkerDescription"
        [done]="product.productPlacement.extraHoogwerkerDone"
        [extraInstructions]="'Type hoogwerker, ...'"
        (answer)="extraHoogwerkerChanged($event)"
        (answeredText)="extraHoogwerkerDescriptionChanged($event)"
        (doneAnswered)="extraHoogwerkerDoneChanged($event)"
      >
      </yes-no>

      <div
        *ngIf="product.productPlacement.extraHoogwerker"
        class="d-flex external-supplier-employee-date"
      >
        <div>
          <div class="form-sub-title">Medewerker</div>

          <mat-form-field class="" appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              name="hoogwerkerEmployee"
              required
              [(ngModel)]="product.productPlacement.extraHoogwerkerEmployee"
              [compareWith]="compareEntities"
            >
              <mat-option
                *ngFor="let option of externalSupplierEmployeeChoices"
                [value]="option"
              >
                {{ option.user.firstName }} {{ option.user.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="left-space">
          <div class="form-sub-title">Deadline</div>

          <mat-form-field appearance="outline">
            <input
              #extraHoogwerkerDeadlineInput
              matInput
              [matDatepicker]="extraHoogwerkerDeadlinePicker"
              placeholder="Selecteer een datum"
              [value]="product.extraHoogwerkerDeadline"
              (dateChange)="extraHoogwerkerDeadlineChange($event)"
            />

            <mat-datepicker-toggle
              matSuffix
              [for]="extraHoogwerkerDeadlinePicker"
            ></mat-datepicker-toggle>

            <mat-datepicker #extraHoogwerkerDeadlinePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <yes-no
        [title]="'Parkeerverbod'"
        [value]="product.productPlacement.parkingBan"
        [nullable]="true"
        [nullIsFalse]="false"
        [done]="product.productPlacement.parkingBanDone"
        [inputText]="product.productPlacement.extraInfoParkingBan"
        (answer)="parkingBanChanged($event)"
        (answeredText)="extraInfoParkingBanChanged($event)"
        (doneAnswered)="parkingBanDoneChanged($event)"
      ></yes-no>

      <div
        *ngIf="product.productPlacement.parkingBan"
        class="d-flex external-supplier-employee-date"
      >
        <div>
          <div class="form-sub-title">Medewerker</div>

          <mat-form-field class="" appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              name="parkingBanEmployee"
              required
              [(ngModel)]="product.productPlacement.parkingBanEmployee"
              [compareWith]="compareEntities"
            >
              <mat-option
                *ngFor="let option of externalSupplierEmployeeChoices"
                [value]="option"
              >
                {{ option.user.firstName }} {{ option.user.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="left-space">
          <div class="form-sub-title">Deadline</div>

          <mat-form-field appearance="outline">
            <input
              #parkingBanDeadlineInput
              matInput
              [matDatepicker]="parkingBanDeadlinePicker"
              placeholder="Selecteer een datum"
              [value]="product.productPlacement.parkingBanDeadline"
              (dateChange)="parkingBanDeadlineChange($event)"
            />

            <mat-datepicker-toggle
              matSuffix
              [for]="parkingBanDeadlinePicker"
            ></mat-datepicker-toggle>

            <mat-datepicker #parkingBanDeadlinePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <yes-no
        [title]="'Extra leverancier nodig'"
        [showExtraInstructionsOn]="'Ja'"
        [value]="product.productPlacement.needExtraSupplier"
        [nullable]="true"
        [nullIsFalse]="false"
        [done]="product.productPlacement.needExtraSupplierDone"
        [inputText]="product.productPlacement.extraInfoNeedExtraSupplier"
        [extraInstructions]="'Geef meer informatie aub'"
        (answer)="needExtraSupplierChanged($event)"
        (answeredText)="extraInfoNeedExtraSupplierChanged($event)"
        (doneAnswered)="needExtraSupplierDoneChanged($event)"
      >
      </yes-no>

      <div
        *ngIf="product.productPlacement.needExtraSupplier"
        class="d-flex external-supplier-employee-date"
      >
        <div>
          <div class="form-sub-title">Medewerker</div>

          <mat-form-field class="" appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              name="extraSupplierEmployee"
              required
              [(ngModel)]="product.productPlacement.extraSupplierEmployee"
              [compareWith]="compareEntities"
            >
              <mat-option
                *ngFor="let option of externalSupplierEmployeeChoices"
                [value]="option"
              >
                {{ option.user.firstName }} {{ option.user.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="left-space">
          <div class="form-sub-title">Deadline</div>

          <mat-form-field appearance="outline">
            <input
              #extraSupplierDeadlineInput
              matInput
              [matDatepicker]="extraSupplierDeadlinePicker"
              placeholder="Selecteer een datum"
              [value]="product.productPlacement.extraSupplierDeadline"
              (dateChange)="extraSupplierDeadlineChange($event)"
            />

            <mat-datepicker-toggle
              matSuffix
              [for]="extraSupplierDeadlinePicker"
            ></mat-datepicker-toggle>

            <mat-datepicker #extraSupplierDeadlinePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <yes-no
        [title]="'Extra materialen nodig'"
        [showExtraInstructionsOn]="'Ja'"
        [value]="product.productPlacement.needExtraMaterials"
        [nullable]="true"
        [nullIsFalse]="false"
        [done]="product.productPlacement.needExtraMaterialsDone"
        [inputText]="product.productPlacement.extraInfoNeedExtraMaterials"
        [extraInstructions]="'Geef meer informatie aub'"
        (answer)="needExtraMaterialsChanged($event)"
        (answeredText)="extraInfoNeedExtraMaterialsChanged($event)"
        (doneAnswered)="needExtraMaterialsDoneChanged($event)"
      >
      </yes-no>

      <div
        *ngIf="product.productPlacement.needExtraMaterials"
        class="d-flex external-supplier-employee-date"
      >
        <div>
          <div class="form-sub-title">Medewerker</div>

          <mat-form-field class="" appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              name="extraMaterialsEmployee"
              required
              [(ngModel)]="product.productPlacement.extraMaterialsEmployee"
              [compareWith]="compareEntities"
            >
              <mat-option
                *ngFor="let option of externalSupplierEmployeeChoices"
                [value]="option"
              >
                {{ option.user.firstName }} {{ option.user.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="left-space">
          <div class="form-sub-title">Deadline</div>

          <mat-form-field appearance="outline">
            <input
              #extraMaterialsDeadlineInput
              matInput
              [matDatepicker]="extraMaterialsDeadlinePicker"
              placeholder="Selecteer een datum"
              [value]="product.productPlacement.extraMaterialsDeadline"
              (dateChange)="extraMaterialsDeadlineChange($event)"
            />

            <mat-datepicker-toggle
              matSuffix
              [for]="extraMaterialsDeadlinePicker"
            ></mat-datepicker-toggle>

            <mat-datepicker #extraMaterialsDeadlinePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <yes-no
        [title]="'Mag het Inpress logo toegevoegd worden?'"
        [neverShowExtraInstructions]="true"
        [value]="product.inpressLogo"
        [nullIsFalse]="false"
        [nullable]="true"
        (answer)="inpressLogoChanged($event)"
      ></yes-no>

      <yes-no
        [title]="'Mag het Immoscoop logo toegevoegd worden?'"
        [neverShowExtraInstructions]="true"
        [value]="product.immoscoopLogo"
        [nullIsFalse]="false"
        [nullable]="true"
        (answer)="immoscoopLogoChanged($event)"
      ></yes-no>

      <yes-no
        [title]="'Mag het Spotto logo toegevoegd worden?'"
        [neverShowExtraInstructions]="true"
        [value]="product.spottoLogo"
        [nullIsFalse]="false"
        [nullable]="true"
        (answer)="spottoLogoChanged($event)"
      ></yes-no>

      <!-- Placement variables -->

      <ng-container *ngIf="withPlacement && product.productPlacement != null">
        <!-- Product specific placement variables -->

        <!-- Window stickers -->

        <div *ngIf="windowSticker != null">
          <div class="title">Afstand vanop de grond tot bovenkant sticker</div>

          <div class="first-form-field">
            <mat-form-field appearance="outline">
              <mat-label>Meter</mat-label>

              <input
                type="number"
                placeholder="Meter"
                matInput
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="product.productPlacement.workHeight"
                required
              />
            </mat-form-field>
          </div>

          <div class="title">Ladder/stelling/hoogwerker</div>

          <mat-form-field class="first-form-field" appearance="outline">
            <mat-select
              matInput
              placeholder="Kies gereedschap"
              [(ngModel)]="product.productPlacement.heightEquipment"
              [ngModelOptions]="{ standalone: true }"
              [compareWith]="compareEnums"
              required
            >
              <mat-option
                *ngFor="let equipment of heightEquipmentOptions"
                [value]="equipment"
              >
                {{ equipment.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <yes-no
            [title]="'Obstakels aan het raam'"
            [showExtraInstructionsOn]="'Ja'"
            [extraInstructions]="
              'Gelieve uitleg op te geven over de obstakels aan het raam'
            "
            [value]="product.productPlacement.windowObstacle"
            [inputText]="product.productPlacement.extraInfoWindowObstacle"
            [nullIsFalse]="false"
            [nullable]="true"
            (answer)="windowObstacleChanged($event)"
            (answeredText)="extraInfoWindowObstacleChanged($event)"
          >
          </yes-no>

          <yes-no
            [title]="'Oude stickers aanwezig'"
            [showExtraInstructionsOn]="'Ja'"
            [extraInstructions]="
              'Gelieve uitleg op te geven over, bv. dienen deze verwijderd te worden'
            "
            [value]="product.productPlacement.oldStickerPresent"
            [inputText]="product.productPlacement.extraInfoOldStickerPresent"
            [nullIsFalse]="false"
            [nullable]="true"
            (answer)="oldStickerPresentChanged($event)"
            (answeredText)="extraInfoOldStickerPresentChanged($event)"
          >
          </yes-no>

          <textarea-input
            [title]="'Uitlijnen van de sticker op het raam'"
            [placeholder]="'Hoe/waar moet de sticker gekleefd worden?'"
            [initContent]="product.productPlacement.alignment"
            (answer)="alignmentChanged($event)"
          ></textarea-input>

          <yes-no
            [title]="'Kleefinstructies'"
            [neverShowExtraInstructions]="true"
            [yesValue]="'Binnenkant'"
            [noValue]="'Buitenkant'"
            [value]="product.productPlacement.inside"
            (answer)="insideChanged($event)"
          >
          </yes-no>

          <yes-no
            [title]="'Hoe kleven (nat of droog)'"
            [neverShowExtraInstructions]="true"
            [yesValue]="'Nat'"
            [noValue]="'Droog'"
            [value]="product.productPlacement.wet"
            (answer)="wetChanged($event)"
          >
          </yes-no>
        </div>

        <!-- Boards -->

        <div *ngIf="board != null">
          <textarea-input
            [title]="'Afstand voorste paal tot straat'"
            [placeholder]="'Info afstand voorste paal tot straat'"
            [initContent]="board.distanceFrontPostToStreet"
            (answer)="distanceFrontPostToStreetChanged($event)"
          ></textarea-input>

          <yes-no
            [title]="'Houten palen'"
            [neverShowExtraInstructions]="true"
            [value]="board.productPlacement.newWoodPosts"
            [yesValue]="'Nieuw hout'"
            [noValue]="'Recup hout'"
            [nullIsFalse]="false"
            [nullable]="true"
            (answer)="newWoodPostsChanged($event)"
          >
          </yes-no>

          <yes-no
            [title]="'Zijn er obstakels'"
            [showExtraInstructionsOn]="'Ja'"
            [nullIsFalse]="false"
            [nullable]="true"
            [value]="board.productPlacement.obstaclesPresent"
            [inputText]="board.productPlacement.obstaclesInfo"
            [extraInstructions]="
              'Is er een omheining of zijn er herashekken? Staan er dieren in de wei?'
            "
            (answer)="boardObstaclesPresentChanged($event)"
            (answeredText)="boardObstaclesInfoTextChanged($event)"
          >
          </yes-no>

          <yes-no
            *ngIf="
              locationVerificationProjectWideDisplay.showNearbyParkingQuestion
            "
            [title]="'Kan er vlakbij geparkeerd worden'"
            [showExtraInstructionsOn]="'Ja'"
            [nullIsFalse]="false"
            [nullable]="true"
            [value]="locationVerificationProjectWideDisplay.nearbyParkingValue"
            [inputText]="
              locationVerificationProjectWideDisplay.nearbyParkingInfo
            "
            [sensitiveText]="true"
            [extraInstructions]="'Geef meer informatie aub.'"
            (answer)="nearbyParkingChanged($event)"
            (answeredText)="nearbyParkingInfoChanged($event)"
          >
          </yes-no>
        </div>

        <!-- Other product -->

        <div *ngIf="otherProduct != null">
          <yes-no
            [title]="'Zijn er obstakels'"
            [showExtraInstructionsOn]="'Ja'"
            [nullIsFalse]="false"
            [nullable]="true"
            [value]="otherProduct.productPlacement.obstaclesPresent"
            [inputText]="otherProduct.productPlacement.obstaclesInfo"
            [extraInstructions]="
              'Is er een omheining of zijn er herashekken? Staan er dieren in de wei?'
            "
            (answer)="otherProductObstaclesPresentChanged($event)"
            (answeredText)="otherProductObstaclesInfoTextChanged($event)"
          >
          </yes-no>
        </div>
      </ng-container>

      <div
        *ngIf="
          locationVerificationProjectWideDisplay.subProject.projectPlacement !=
          null
        "
      >
        <div class="form-title small-upper-space">
          <div class="form-title-text">Plaatsing</div>
        </div>

        <yes-no
          [title]="'Afspraak nodig'"
          [showExtraInstructionsOn]="'Ja'"
          [extraInstructions]="'Meer info omtrent de afspraak hier'"
          [value]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
              .appointment
          "
          [inputText]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
              .needAppointmentInfo
          "
          [nullIsFalse]="true"
          [nullable]="false"
          [sensitiveText]="true"
          (answer)="appointmentChanged($event)"
          (answeredText)="needAppointmentInfoChanged($event)"
        ></yes-no>

        <div
          class="d-flex"
          [ngClass]="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
              .collectKey
              ? ''
              : 'under-space'
          "
        >
          <yes-no
            [title]="'Sleutel afhalen'"
            [neverShowExtraInstructions]="true"
            [nullable]="false"
            [nullIsFalse]="true"
            [value]="
              locationVerificationProjectWideDisplay.subProject.projectPlacement
                .collectKey
            "
            (answer)="collectKeyChanged($event)"
          ></yes-no>

          <div
            *ngIf="
              locationVerificationProjectWideDisplay.subProject.projectPlacement
                .collectKey
            "
            class="left-fifteen-space align-collect-key-from collect-key-from-width"
          >
            <collect-key-from-selector
              [projectPlacement]="
                locationVerificationProjectWideDisplay.subProject
                  .projectPlacement
              "
              [project]="locationVerificationProjectWideDisplay.project"
            ></collect-key-from-selector>
          </div>
        </div>

        <div
          *ngIf="
            locationVerificationProjectWideDisplay.subProject.projectPlacement
              .collectKeyFrom === -1
          "
          class="align-collect-key-extra-info-with-selector"
        >
          <textarea-input
            [placeholder]="'Adres noteren + openingsuren'"
            [initContent]="
              locationVerificationProjectWideDisplay.subProject.projectPlacement
                .collectKeyExtraInfo
            "
            (answer)="collectKeyExtraInfoChange($event)"
          ></textarea-input>
        </div>
      </div>

      <ng-container *ngIf="product.productPlacement != null">
        <div class="d-flex">
          <div>
            <div class="form-sub-title">Medewerker</div>

            <mat-form-field class="" appearance="outline">
              <mat-select
                matInput
                multiple
                placeholder="Maak een keuze"
                required
                [(ngModel)]="product.productPlacement.placers"
                name="placer"
                [compareWith]="compareEntities"
              >
                <mat-option
                  *ngFor="let option of placerChoices"
                  [value]="option"
                >
                  {{ option.user.firstName }} {{ option.user.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="flex-grow-1">
            <div class="form-field form-sub-title">Gekozen medewerker(s)</div>

            <p
              class="title-top form-field"
              *ngIf="
                product.productPlacement.placers == null ||
                product.productPlacement.placers.length === 0
              "
            >
              Geen medewerkers gekozen
            </p>

            <ul
              class="form-field inpress-ul"
              *ngIf="
                product.productPlacement.placers != null &&
                product.productPlacement.placers.length > 0
              "
            >
              <li *ngFor="let placer of product.productPlacement.placers">
                {{ placer.user.firstName }} {{ placer.user.lastName }}
              </li>
            </ul>
          </div>
        </div>

        <div class="d-flex">
          <checkbox
            [title]="'Gevraagde plaatsingsdatum'"
            [text]="'Het project moet ASAP geplaatst worden'"
            [checked]="
              locationVerificationProjectWideDisplay.subProject.projectPlacement
                .placeASAP
            "
            (answer)="placeASAP($event)"
          ></checkbox>

          <div class="next-to-checkbox"><b>OF</b></div>

          <mat-form-field class="next-to-checkbox-last" appearance="outline">
            <input
              matInput
              [matDatepicker]="placementPicker"
              placeholder="Selecteer een datum"
              [(ngModel)]="
                locationVerificationProjectWideDisplay.subProject
                  .projectPlacement.placementEarliestDate
              "
              (ngModelChange)="placementEarliestDateChange($event)"
            />

            <mat-datepicker-toggle
              matSuffix
              [for]="placementPicker"
            ></mat-datepicker-toggle>

            <mat-datepicker #placementPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="title">Effectieve plaatsingsdatum</div>

        <div class="d-flex small-upper-space">
          <p>Gekozen door klant: {{ requestedDateDisplay }}</p>

          <button
            *ngIf="
              !locationVerificationProjectWideDisplay.subProject
                .projectPlacement?.placeASAP &&
              locationVerificationProjectWideDisplay.subProject.projectPlacement
                ?.placementEarliestDate != null
            "
            type="button"
            mat-button
            class="copy-button"
            (click)="copyProjectPlacementDate()"
          >
            Neem datum over
          </button>
        </div>

        <div *ngIf="!product.productPlacement.placeASAP" class="d-flex">
          <mat-form-field appearance="outline">
            <input
              #actualPlacementInput
              matInput
              [matDatepicker]="actualPlacementPicker"
              placeholder="Selecteer een datum"
              [value]="product.productPlacement.actualPlacementDate"
              [disabled]="product.productPlacement.actualPlacementDateConfirmed"
              (dateChange)="actualPlacementDateChange($event)"
            />

            <mat-datepicker-toggle
              matSuffix
              [for]="actualPlacementPicker"
            ></mat-datepicker-toggle>

            <mat-datepicker #actualPlacementPicker></mat-datepicker>
          </mat-form-field>

          <div class="align-placement-date-confirmed-checkbox">
            <checkbox
              [checked]="product.productPlacement.actualPlacementDateConfirmed"
              [text]="'Datum vastzetten'"
              [isDisabled]="
                product.productPlacement.actualPlacementDate == null
              "
              (answer)="actualPlacementDateConfirmedChange($event)"
            ></checkbox>
          </div>
        </div>

        <div class="form-sub-title">Voorziene tijd installateur</div>

        <form class="form">
          <div class="d-flex">
            <div class="timeInput">
              <div class="selector-label">Uren</div>

              <mat-form-field class="timeInput" appearance="outline">
                <mat-select
                  matInput
                  class="timeInputSelect"
                  required
                  [(ngModel)]="product.productPlacement.installerHourBudget"
                  name="installerHourBudget"
                  [compareWith]="compareNumbers"
                >
                  <mat-option
                    *ngFor="let option of hours"
                    [value]="option"
                    class="timeInputSelect"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="largeText">:</div>

            <div class="timeInput">
              <div class="selector-label">Minuten</div>

              <mat-form-field class="timeInput" appearance="outline">
                <mat-select
                  matInput
                  class="timeInputSelect"
                  required
                  [(ngModel)]="product.productPlacement.installerMinuteBudget"
                  name="installerMinuteBudget"
                  [compareWith]="compareNumbers"
                >
                  <mat-option
                    *ngFor="let option of minutes"
                    [value]="option"
                    class="timeInputSelect"
                  >
                    {{ option }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </form>
      </ng-container>
    </ng-container>
  </div>
</mat-card>
